import { atom } from 'jotai';

export interface Location {
  href: string;
  path: string;
  hasNav?: boolean;
  origin: string;
}

export const $Location = atom<Location>({
  href: '',
  path: '',
  hasNav: true,
  origin: '',
});

$Location.debugLabel = '$Location';
